<template>
  <div>
    <section-title
      content="Información de Facilitación de Libro"
      has-line
      class="mt-4"
    />
    <div class="m-2 pt-1">
      <div class="row mb-2">
        <div class="col-12 col-lg-2 mb-4">
          <p class="font-14 text-muted mb-1">
            Tipo de Facilidad:
          </p>
          <p class="font-16">
            {{ loan.type | empty }}
          </p>
        </div>
        <div class="col-12 col-lg-3 mb-4">
          <p class="font-14 text-muted mb-1">
            Nombre del Estudiante:
          </p>
          <p class="font-16">
            {{ loan.student | empty }}
          </p>
        </div>
        <div class="col-12 col-lg-3 mb-4">
          <p class="font-14 text-muted mb-1">
            Razón:
          </p>
          <p class="font-16">
            {{ loan.reason | empty }}
          </p>
        </div>
        <div class="col-12 col-lg-2 mb-4">
          <p class="font-14 text-muted mb-1">
            Centro:
          </p>
          <p class="font-16">
            {{ loan.caat | empty }}
          </p>
        </div>
        <div class="col-12 col-lg-2 mb-4">
          <p class="font-14 text-muted mb-1">
            Fecha de Devolución Estimada:
          </p>
          <p class="font-16">
            {{ loan.returnDate | date }}
          </p>
        </div>
      </div>
    </div>

    <div class="m-2 pt-1">
      <div class="row mb-2">
        <div class="col-12 col-lg-2 mb-4">
          <p class="font-14 text-muted mb-1">
            Fecha de Extensión:
          </p>
          <p class="font-16">
            {{ loan.extensionDate | date }}
          </p>
        </div>
        <div class="col-12 col-lg-3 mb-4">
          <p class="font-14 text-muted mb-1">
            Fecha de Facilitación:
          </p>
          <p class="font-16">
            {{ loan.createdDate | date }}
          </p>
        </div>
        <div class="col-12 col-lg-3 mb-4">
          <p class="font-14 text-muted mb-1">
            Realizado por:
          </p>
          <p class="font-16">
            {{ loan.createdBy | empty }}
          </p>
        </div>
      </div>
    </div>
    <div class="m-2 pt-1">
      <div class="row mb-2">
        <div class="col-12 col-lg-2 mb-4">
          <p class="font-14 text-muted mb-1">
            Comentario:
          </p>
          <p class="font-16">
            {{ loan.comment | empty }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "SectionTitle";

export default {
  name: "loanInformation",
  components: {
    SectionTitle
  },
  props: {
    loan: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped></style>
